import * as React from "react";

interface BrowserViewerProps extends React.Attributes {
    url?: string;
    dataCy?: string;
}

export const BrowserViewer = (props: BrowserViewerProps) => {
    const { url, dataCy } = props;

    if (!url) return null;

    return (
        <iframe
            title="relode document viewer"
            data-cy={dataCy}
            key={url}
            style={{ width: "100%", height: "100%" }}
            src={url}
        />
    );
};
